export const LOGO_URL = "https://customer-assets.emergentagent.com/job_a6424444-4bd2-4dfc-a527-a29f0ef32faf/artifacts/231eyq9w_image.png";
export const CAR_2012_URL = "https://customer-assets.emergentagent.com/job_a6424444-4bd2-4dfc-a527-a29f0ef32faf/artifacts/nbw13tc7_image.png";
export const CAR_2010_URL = "https://customer-assets.emergentagent.com/job_a6424444-4bd2-4dfc-a527-a29f0ef32faf/artifacts/n65lva2k_image.png";

// Real Cleavie's Enterprise photography
export const WATER_TRUCK_URL = "https://customer-assets.emergentagent.com/job_cleavies-booking-1/artifacts/2529gj51_image.png";
export const TRUCK_BIN_URL = "https://customer-assets.emergentagent.com/job_cleavies-booking-1/artifacts/gr52s4ar_Truck%20Bin.jpeg";
export const TRUCK_TRIP_URL = "https://customer-assets.emergentagent.com/job_cleavies-booking-1/artifacts/narnan3z_Truck%20Trip.jpeg";

// Aliases used across pages
export const WATER_IMG = WATER_TRUCK_URL;
export const BIN_IMG = TRUCK_BIN_URL;
export const TRUCKING_IMG = TRUCK_TRIP_URL;
export const HERO_TRUCKING = WATER_TRUCK_URL; // water truck is the hero of the trucking portal

export const CONTACT = {
  phone: "+1 (268) 726-5554",
  email: "cleaviesenterprise@gmail.com",
  address: "Lightfoot West, St. John's, Antigua & Barbuda",
};

export const ROLE_LABELS = {
  customer: "Customer",
  driver: "Driver",
  dispatcher: "Dispatcher",
  admin: "Administrator",
};

export const STATUS_LABELS = {
  pending: "Pending",
  approved: "Approved",
  assigned: "Assigned",
  in_progress: "In Progress",
  completed: "Completed",
  cancelled: "Cancelled",
  quoted: "Quote Requested",
};

export const STATUS_COLORS = {
  pending: "bg-amber-100 text-amber-900 border-amber-200",
  approved: "bg-blue-100 text-blue-900 border-blue-200",
  assigned: "bg-indigo-100 text-indigo-900 border-indigo-200",
  in_progress: "bg-yellow-100 text-yellow-900 border-yellow-300",
  completed: "bg-emerald-100 text-emerald-900 border-emerald-200",
  cancelled: "bg-slate-100 text-slate-700 border-slate-200",
  quoted: "bg-fuchsia-100 text-fuchsia-900 border-fuchsia-200",
};

export function formatXCD(n) {
  if (n == null) return "—";
  return `EC$${Number(n).toLocaleString()}`;
}
